const COMMON_LOGS_DATA_MODEL = {
  equipmentId: {
    key: "equipmentId",
    value: "Equipment ID"
  },
  serialNumber: {
    key: "serialNumber",
    value: "Serial number"
  },
  equipmentNickName: {
    key: "equipmentNickName",
    value: "Nickname"
  },
  equipmentModel: {
    key: "equipmentModel",
    value: "Model"
  },
  equipmentCategory: {
    key: "equipmentCategory",
    value: "Category"
  },
  description: {
    key: "description",
    value: "Description"
  },
  fullDescription: {
    key: "description",
    value: "Full description"
  },
  approverUserName: {
    key: "approverUserName",
    value: "Signee"
  },
  operatorUserName: {
    key: "operatorUserName",
    value: "Operator"
  },
  materialNumber: {
    key: "materialNumber",
    value: "Material number"
  },
  manufacturer: {
    key: "manufacturer",
    value: "Manufacturer"
  },
  softwareVersion: {
    key: "softwareVersion",
    value: "Software version"
  },
  configuration: {
    key: "configurationBaseline",
    value: "Configuration baseline"
  },
  location: {
    key: "location",
    value: "Location"
  },
  responsiblePerson: {
    key: "responsiblePerson",
    value: "Responsible person"
  },
  responsibleProxy: {
    key: "responsibleProxy",
    value: "Responsible proxy"
  },
  runStartDate: {
    key: "runStartDate",
    value: "Run start date"
  },
  runEndDate: {
    key: "runEndDate",
    value: "Run end date"
  },
  variant: {
    key: "variant",
    value: "Variant"
  },
  subEquipment: {
    key: "subEquipment",
    value: "Sub components"
  },
  tipsUsed: {
    key: "tipsUsed",
    value: "Consumables"
  },
  approveActionLog: {
    key: "approveActionLog",
    value: "Approve action log"
  },
  attachments: {
    key: "attachments",
    value: "Attachments"
  },
  divider: {
    key: "divider",
    value: "Divider"
  },
  externalDocument: {
    key: "externalDocument",
    value: "External document"
  },
  approveStatus: {
    key: "approveStatus",
    value: "Approve status"
  },
  createdAt: {
    key: "createdAt",
    value: "Creation date"
  },
  createdAtTime: {
    key: "createdAt",  // Same data field as createdAt, different display label
    value: "Creation time"
  },
  gxpRelevant: {
    key: "gxpRelevant",
    value: "Intended use GxP relevant"
  }
};

export default COMMON_LOGS_DATA_MODEL;
